import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "g-grid-container" }

import { toRefs } from 'vue'
import provideConfig from "../provider/provideConfig"
import useTimeaxisUnits from "../composables/useTimeaxisUnits"
import dayjs from "dayjs"
import { isWeekday } from '@/ganttastic/composables/useDayjsHelper'

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'GGanttGrid',
  props: {
    highlightedUnits: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "581ba0d2": (_unref(gridWeekendBg))
}))



const { colors } = toRefs(provideConfig())
const { timeaxisUnits } = toRefs(useTimeaxisUnits())
const gridWeekendBg = colors.value.weekendSoft

const getGridLineClass = (date: string|Date) => {
  if (!isWeekday(dayjs(date))) return "g-grid-line-weekend"
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeaxisUnits).lowerUnits, ({ label, value, date, width }) => {
      return (_openBlock(), _createElementBlock("div", {
        key: label,
        class: _normalizeClass(["g-grid-line", getGridLineClass(date)]),
        style: _normalizeStyle({
        width,
        background: _ctx.highlightedUnits?.includes(Number(value)) ? _unref(colors).hoverHighlight : undefined
      })
      }, null, 6))
    }), 128))
  ]))
}
}

})